import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import { LoadingController } from "@ionic/angular";
import { IframePage } from "../iframe/iframe.page";

@Component({
  selector: "app-domain-address",
  templateUrl: "../iframe/iframe.page.html",
  styleUrls: ["../iframe/iframe.page.scss"],
})
export class DomainAddressPage extends IframePage {
  constructor(protected _store: Store<RootState>, protected _loadingController: LoadingController, private sanitizer: DomSanitizer) {
    super(_store, _loadingController);
    this.title = "Deine Internetadresse";
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
      "https://docs.google.com/forms/d/e/1FAIpQLScQVH_TimNKRfO0tavkmn8KgAESOCuo4TH42PmPoq4oBXaLuQ/viewform?usp=sf_link",
    );
  }
}
